<template>
  <ModifyIndustrialPropertyForm v-if="formName === 'modifyIndustrialPropertyForm'" />
  <NewIndustrialPropertyForm v-else />
</template>
<script>
import ModifyIndustrialPropertyForm from "./ModifyIndustrialPropertyForm.vue";
import NewIndustrialPropertyForm from "./NewIndustrialPropertyForm.vue";
export default {
  name: "IndustrialPropertyForms",
  components: { ModifyIndustrialPropertyForm, NewIndustrialPropertyForm },
  computed: { formName() { return this.$route.params.formName || this.$route.params.form_name; } }
};
</script>
